import { Component, Injector, OnInit } from '@angular/core';
import { Reward } from 'src/app/models/point';
import { PointService } from 'src/app/services/point.service';
import { ClipboardService } from 'ngx-clipboard';
import { ViewChild } from '@angular/core';
import { AlertComponent } from 'src/app/alert/alert.component';

declare var $: any;

@Component({
  selector: 'app-reward',
  templateUrl: './reward.component.html',
  styleUrls: ['./reward.component.css']
})
export class RewardComponent implements OnInit {
  @ViewChild("alertModal") alertModal: AlertComponent;

  public activeRewards: Reward[] = [];
  public activeIsLoading = false;
  public activeOffset = 0;
  public activeLimit = 10;
  public activeCanShowMore = false;

  public expiredRewards: Reward[] = [];
  public expiredIsLoading = false;
  public expiredOffset = 0;
  public expiredLimit = 10;
  public expiredCanShowMore = false;

  public usedRewards = [];
  public usedIsLoading = false;
  public usedOffset = 0;
  public usedLimit = 10;
  public usedCanShowMore = false;

  public voucher: Reward;

  public placeholderText = '';
  public isProvider = false;
  public accountNumber: any;
  public alertAccountNumber = '';
  public isSuccess: boolean;
  public infoVoucher: any;
  public statusVoucher: any;

  public activeTab = null;
  public copyClicked = false;
  count417 = 0;

  constructor(
    private pointService: PointService,
    private clipboardService: ClipboardService
  ) { }

  ngOnInit() {
    const type = localStorage.getItem('voucherType');
    if (type) {
      if (type === '9') {
        localStorage.setItem('voucherType', '');
        this.activeTab = 'used';
        this.getActiveReward();
        this.getExpiredReward();
        this.getUsedReward();
      } else if (type === '10') {
        localStorage.setItem('voucherType', '');
        this.activeTab = 'active';
        this.getActiveReward();
        this.getExpiredReward();
        this.getUsedReward();
      }
    } else {
      this.activeTab = 'active';
      this.getActiveReward();
      this.getExpiredReward();
      this.getUsedReward();
    }
  }

  applyJqueryScript(): void {
    $(document).ready(function () {
      $('ul.tabs li').click(function () {
        const tab_id = $(this).attr('data-tab');

        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $('#' + tab_id).addClass('current');
      });
    });
  }

  getActiveReward() {
    this.activeIsLoading = true;
    this.pointService.getReward(this.activeOffset, this.activeLimit,
      (data) => {
        this.activeIsLoading = false;

        this.activeRewards = data;
        if (data.length >= 10) {
          this.activeCanShowMore = true;
        } else {
          this.activeCanShowMore = false;
        }
      },
      (err) => {
        this.activeIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  getExpiredReward() {
    this.expiredIsLoading = true;
    this.pointService.getRewardExpired(this.expiredOffset, this.expiredLimit,
      (data) => {
        this.expiredIsLoading = false;

        this.expiredRewards = data;
        if (data.length >= 10) {
          this.expiredCanShowMore = true;
        } else {
          this.expiredCanShowMore = false;
        }
      },
      (err) => {
        this.expiredIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  getUsedReward() {
    this.usedIsLoading = true;
    this.pointService.getRewardUsed(this.usedOffset, this.usedLimit,
      (data) => {
        this.usedIsLoading = false;

        this.usedRewards = data;
        if (data.length >= 10) {
          this.usedCanShowMore = true;
        } else {
          this.usedCanShowMore = false;
        }
      },
      (err) => {
        this.usedIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  activeShowMore() {
    this.activeIsLoading = true;
    this.activeCanShowMore = false;
    this.activeOffset += this.activeLimit;

    this.pointService.getReward(this.activeOffset, this.activeLimit,
      (data) => {
        this.activeIsLoading = false;

        data.forEach(item => {
          this.activeRewards.push(item);
        });

        if (data.length >= 10) {
          this.activeCanShowMore = true;
        }
      },
      (err) => {
        this.activeIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  expiredShowMore() {
    this.expiredIsLoading = true;
    this.expiredCanShowMore = false;
    this.expiredOffset += this.expiredLimit;

    this.pointService.getRewardExpired(this.expiredOffset, this.expiredLimit,
      (data) => {
        this.expiredIsLoading = false;

        data.forEach(item => {
          this.expiredRewards.push(item);
        });

        if (data.length >= 10) {
          this.expiredCanShowMore = true;
        }
      },
      (err) => {
        this.expiredIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  usedShowMore() {
    this.usedIsLoading = true;
    this.usedCanShowMore = false;
    this.usedOffset += this.usedLimit;

    this.pointService.getRewardUsed(this.usedOffset, this.usedLimit,
      (data) => {
        this.usedIsLoading = false;

        data.forEach(item => {
          this.usedRewards.push(item);
        });

        if (data.length >= 10) {
          this.usedCanShowMore = true;
        }
      },
      (err) => {
        this.usedIsLoading = false;
        this.alertModal.show('Gagal Menampilkan Data', err.message);
      }
    );
  }

  public useVoucher(reward: Reward): void {
    this.alertAccountNumber = '';
    this.voucher = reward;
    if (reward.voucher_category === 'Pulsa All Provider' || reward.voucher_category === 'Paket Data Provider') {
      this.isProvider = true;
      this.placeholderText = 'Contoh No. Ponsel : 62813xxxxxxxx';
    } else {
      this.isProvider = false;
      this.placeholderText = '';
    }
    $('#useVoucher').modal('show');
  }

  public confirmUseVoucher(): void {
    if (!this.accountNumber) {
      if (this.voucher.voucher_category === 'Pulsa All Provider' || this.voucher.voucher_category === 'Paket Data Provider') {
        this.alertAccountNumber = 'No. Ponsel harus diisi';
      } else {
        this.alertAccountNumber = 'No. Meter harus diisi';
      }
      return;
    }

    this.alertAccountNumber = '';

    const param = {
      voucher_code: this.voucher.voucher_no,
      voucher_catalog_id: btoa(this.voucher.voucher_catalog_id),
      account_number: btoa(this.accountNumber),
      reference_id: ''
    };

    $('#useVoucher').modal('hide');
    $('#loader').modal('show');
    this.pointService.postUseVoucher(param,
      data => {
        this.isSuccess = true;
        $('#loader').modal('hide');
        $('#infoVoucher').modal('show');
      },
      err => {
        this.isSuccess = false;
        $('#loader').modal('hide');
        $('#infoVoucher').modal('show');
      }
    );

    this.accountNumber = '';
  }

  cancelUseVoucher() {
    this.accountNumber = '';
    $('#useVoucher').modal('hide');
  }

  onOkUseVoucher() {
    $('#infoVoucher').modal('hide');
    this.activeCanShowMore = false;
    this.activeRewards = [];
    this.activeOffset = 0;
    this.activeLimit = 10;
    this.getActiveReward();
  }

  checkStatusVoucher(reward: Reward): void {
    $('#loader').modal('show');
    this.pointService.getStatusRedeem(reward.voucher_no,
      (data) => {
        this.statusVoucher = data;
        $('#loader').modal('hide');
        $('#statusVoucher').modal('show');
      },
      (err) => {
        this.statusVoucher = null;
        $('#loader').modal('hide');
      }
    );
  }

  onOkStatusVoucher() {
    $('#statusVoucher').modal('hide');

    if (this.statusVoucher.statusCode === '1') {
      this.activeTab = 'used';
      this.usedCanShowMore = false;
      this.usedRewards = [];
      this.usedOffset = 0;
      this.usedLimit = 10;
      this.getUsedReward();
    } else {
      this.activeTab = 'active';
      this.activeCanShowMore = false;
      this.activeRewards = [];
      this.activeOffset = 0;
      this.activeLimit = 10;
      this.getActiveReward();
    }
  }

  seeToken(data: any) {
    this.infoVoucher = data;
    $('#seeTokenVoucher').modal('show');
  }

  copyToken(token: string) {
    this.clipboardService.copyFromContent(token);
    this.copyClicked = true;
    setTimeout(() => {
      this.copyClicked = false;
    }, 3000);
  }

  public tabActive(): void {
    this.activeTab = 'active';
    this.activeOffset = 0;
    this.activeLimit = 10;
    this.getActiveReward();
  }

  public tabExpired(): void {
    this.activeTab = 'expired';
    this.expiredOffset = 0;
    this.expiredLimit = 10;
    this.getExpiredReward();
  }

  public tabUsed(): void {
    this.activeTab = 'used';
    this.usedOffset = 0;
    this.usedLimit = 10;
    this.getUsedReward();
  }
}
